module.exports = __webpack_public_path__ + "static/media/Athelstan 1.1a57be22.jpg";